module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('download-Popup'), _vm._v(" "), (_vm.isOperamini) ? _c('p', {
    staticClass: "operamini-tips"
  }, [_vm._v("In order to give you a better experience, please download our\n        professional APP.")]) : _vm._e(), _vm._v(" "), _c('downloadheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.downLoadHeaderShow),
      expression: "downLoadHeaderShow"
    }],
    attrs: {
      "id": "headwrap"
    }
  }), _vm._v(" "), _c('navVue', {
    attrs: {
      "subtitleData": _vm.getStatsSubTabList,
      "navSelected": _vm.currentNavTag,
      "isThirdTit": true,
      "loadingShowProp": _vm.getStatsLoadingShow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contentWrap",
    staticStyle: {
      "min-height": "35rem"
    },
    attrs: {
      "id": "contentWrap"
    }
  }, [(_vm.getStatsLoadingShow) ? _c('loading', {
    attrs: {
      "statsLoading": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('nodata', {
    attrs: {
      "whiteMode": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Table' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('tables', {
    attrs: {
      "tableData": _vm.getCurrentStatsListData,
      "noDataModeObj": _vm.getStatsNoDataMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Goals' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('goals', {
    attrs: {
      "goalData": _vm.getCurrentStatsListData,
      "noDataModeShow": _vm.getStatsNoDataMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Assists' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('assists', {
    attrs: {
      "assistsData": _vm.getCurrentStatsListData,
      "noDataModeShow": _vm.getStatsNoDataMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thirdTitChoose === 'Fixtures' && !_vm.getStatsNoDataMode && !_vm.getStatsLoadingShow) ? _c('fixtures', {
    attrs: {
      "fixtures": _vm.getCurrentStatsListData,
      "noDataModeShow": _vm.getStatsNoDataMode
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c85f4cd","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppStats.vue
// module id = 685
// module chunks = 3